//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BUS, isElectron, isMobile } from "../../../tools/tools";

export default {
  name: "Login",
  inject: ["avatarConfig", "plugin"],
  props: {
    userInfo: {
      default: {},
    },
  },
  data() {
    return {
      user: null,
      listMode: {
        theme: false, // 主题切换
        community: true, // 社区
        personal: false, // 个人主页
        website: false, // 官网
        plugin: false, // 插件
        setting: true, // 设置
        logout: true, // 退出登录
      },
      avatarSize: "middle", // 头像显示的尺寸大小
      theme: "light",
      usePointer: true, // 是否修改鼠标hover状态
      isResourceSquare: false, // 是否是资源广场，资源广场在移动端有不同的显示
      headType: "default", // withButton 有返回工作台按钮
      isClient: false
    };
  },
  methods: {
    setavatarConfig() {
      if (!this.avatarConfig) return;
      Object.keys(this.avatarConfig).forEach((key) => {
        this[key] = this.avatarConfig[key];
      });
    },
    loginHandle() {
      // 打开登陆弹窗
      BUS.emit("openLogin", {
        openLogin: true,
        isRegister: false,
        options: {
          actionDetail: {
            login_popout_load: "header_login",
            click_lanhuoauthbtn: "login_popout",
            wechat_qr_load: "login_popout",
          },
        },
      });
    },
    registerHandle() {
      // 打开注册弹窗
      BUS.emit("openLogin", {
        openLogin: true,
        isRegister: true,
        options: {
          actionDetail: {
            login_popout_load: "header_register",
            click_lanhuoauthbtn: "login_popout",
            wechat_qr_load: "login_popout",
          },
        },
      });
    },
    logOutHandle(route) {
      // 退出登陆
      const { type } = route;
      if (type === "logout") {
        // 退出登陆
        this.logOut();
        if (process.client) {
          sessionStorage.setItem("websiteUserState", false);
        }
      }
      BUS.emit("MHead", {
        type: "logOut",
        datas: arguments,
      });
    },
    logOut() {
      this.plugin.logout();
      this.user = null;
      localStorage.removeItem("userInfo");
      BUS.emit("MHead", {
        type: "logOut",
        datas: arguments,
      });
    },
    topath(route) {
      // 头像下拉跳转
      const { path } = route;

      BUS.emit("MHead", {
        type: "topath",
        datas: arguments,
      });
      if (window && location) {
        location.href = `${location.origin}${path}`;
      }
    },
    getLocalStorageUserInfo() {
      const user = localStorage.userInfo;
      if (user) {
        this.user = JSON.parse(user);
      }
    },
    gotoDownload(data) {
      const downloadType = data?.toursName
      const sourceIds = {
        'mobile-app': 'mobile-app-download',
        'pc-app': 'client-download',
        'font-extension': 'font-extension-download'
      }
      if(!sourceIds[downloadType]) return
      window.open(`/resource#${sourceIds[downloadType] || ''}`)
    }
  },
  created() {
    if (this.isClient) {
      this.listMode.logout = false;
    }
    if (process.client) {
      if (!isMobile()) {
        this.headType = "withButton";
      }
      this.getLocalStorageUserInfo();
    }
  },
  mounted() {
    BUS.on("setUserInfo", (userdatas) => {
      this.user = userdatas;
    });
    this.isClient = isElectron()
  },
  destroyed() {
    BUS.off("setUserInfo");
  },
};
